import { nextTick } from 'vue';

export default {
    // When the bound element is inserted into the DOM...
    mounted: function (el) {
        // Focus the element
        nextTick(() => el.focus());
    },
};
